<div class="bp-modal mod-lg wrapper">
	<bp-modal-header
		[title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]"
		class="font-semibold">
		<a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
			{{ "back" | translate }}
		</a>
		<a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
			{{ "cancel" | translate }}
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="bp-modal-description">
				<two-fa [type]="'multichain'" (save)="save($event)"></two-fa>
			</div>
		</div>
	</div>
</div>
